var pickrInstances = {};
var pickrInstances2 = {};
var pickrInstances3 = {};
function generateSections(sectionsConfig) {
    const container = document.getElementById('sections-container');
    clearTabs();
    //container.innerHTML = ''; // Clear the container before generating sections
        sectionsConfig.forEach((section, index) => {
        const sectionDiv = document.createElement('div');
        sectionDiv.id = section.id;
        sectionDiv.classList.add('section');
        if (index !== 0) {
            sectionDiv.style.display = 'none';
        }

        let tab = "";
        if(section.title.includes("Front")){
            tab = 'tent-front';
        }
        else if(section.title.includes("Back")){
            tab = 'tent-back';
        }
        else if(section.title.includes("Right")){
            tab = 'tent-right';
        }
        else{
            tab = 'tent-left';
        }

        sectionDiv.innerHTML = `
            <div>
                <div style="min-height:35px;">
                    <h5>
                        1. Current Section: <span id="current-section" style="font-weight:initial">${section.title}</span>
                    </h5>
                    ${section.title === 'Back Peak' ? '<button id="copy-back-peak" class="btn btn--primary w-full" onclick="copyOppositeSection(\'back-peak\')">Copy Front Peak</button><br><br>' : ''}
                    ${section.title === 'Back Valance' ? '<button id="copy-back-valance" class="btn btn--primary w-full" onclick="copyOppositeSection(\'back-valance\')">Copy Front Valance</button><br><br>' : ''}
                    ${section.title === 'Left Peak' ? '<button id="copy-left-peak" class="btn btn--primary w-full" onclick="copyOppositeSection(\'left-peak\')">Copy Right Peak</button><br><br>' : ''}
                    ${section.title === 'Left Valance' ? '<button id="copy-left-valance" class="btn btn--primary w-full" onclick="copyOppositeSection(\'left-valance\')">Copy Right Valance</button><br><br>' : ''}
                    ${section.title === 'Left Wall' ? '<button id="copy-left-wall" class="btn btn--primary w-full" onclick="copyOppositeSection(\'left-wall\')">Copy Right Wall</button><br><br>' : ''}
                </div>
                <div style="min-height:35px; padding-top:10px">
                    <h5>
                        2. Choose Color: <span id="selected-color-${section.id}" style="font-weight:initial">White</span>
                    </h5>
                    <div style="position: relative; margin-top:-10px;">
                        ${section.colorOptions.map(color => `
                            <input type="radio" id="${section.id}-${color.toLowerCase().replace(' ', '-')}" name="color-${section.id}" value="${color}" class="color-radio" ${color === 'White' ? 'checked' : ''}>
                            <label for="${section.id}-${color.toLowerCase().replace(' ', '-')}">
                                <div class="color-swatch2 ${color.toLowerCase().replace(' ', '-')}">
                                    <div class="hover-box">
                                        <img src="${window.shopifyAssetPaths.tentColors[color]}" alt="${color}">
                                        <span>${color}</span>
                                    </div>
                                </div>
                            </label>
                        `).join('')}
                        <label id="color-picker-${section.id}" class="color-picker"></label>
                    </div>
                </div>
                <div style="min-height:35px; padding-top:10px;">
                    <h5>
                        3. Add Text:
                    </h5>
                    <textarea id="text-input-${section.id}" class="text-input placeholder-grey" style="width:75%; border-radius:3px; border: 1px solid #838383; height: 40px; overflow:hidden; resize:none; vertical-align: middle;" placeholder="Enter text here..." oninput='updateCanvasText(${JSON.stringify(section)})'></textarea>
                    <div style="display: flex; gap: 20px; margin-top: 10px; display: none;" id="color-options-wrapper-${section.id}">
                        <div class="font-style-wrapper" display: none;">
                            <label for="font-style-${section.id}" class="font-style-label">Font: <span id="font-style-required-${section.id}" style="color: red; display: none; padding-left:8px;">*Required</span></label>
                            <div class="custom-dropdown">
                                <button type="button" class="custom-dropdown-button" onclick="toggleDropdown('font-style-${section.id}')">
                                Select a Font Style
                                <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                                </svg>
                                </button>
                                <div id="font-style-${section.id}" class="custom-dropdown-content">
                                    <!-- Font options -->
                                    <div style="font-family: benguiat-bk" onclick="selectDropdownOption('font-style-${section.id}', 'Benguiat BK', '${section.id}')">Benguiat BK</div>
                                    <div style="font-family: cityd-bold" onclick="selectDropdownOption('font-style-${section.id}', 'Cityd Bold', '${section.id}')">Cityd Bold</div>
                                    <div style="font-family: Deadknight" onclick="selectDropdownOption('font-style-${section.id}', 'Deadknight', '${section.id}')">Deadknight</div>
                                    <div style="font-family: demonized" onclick="selectDropdownOption('font-style-${section.id}', 'Demonized', '${section.id}')">Demonized</div>
                                    <div style="font-family: eurostile" onclick="selectDropdownOption('font-style-${section.id}', 'Eurostile', '${section.id}')">Eurostile</div>
                                    <div style="font-family: evogria" onclick="selectDropdownOption('font-style-${section.id}', 'Evogria', '${section.id}')">Evogria</div>
                                    <div style="font-family: evogria-italic" onclick="selectDropdownOption('font-style-${section.id}', 'Evogria Italic', '${section.id}')">Evogria Italic</div>
                                    <div style="font-family: Famous-College" onclick="selectDropdownOption('font-style-${section.id}', 'Famous College', '${section.id}')">Famous College</div>
                                    <div style="font-family: Keylock-Fighter" onclick="selectDropdownOption('font-style-${section.id}', 'Keylock Fighter', '${section.id}')">Keylock Fighter</div>
                                    <div style="font-family: magnolia-script" onclick="selectDropdownOption('font-style-${section.id}', 'Magnolia Script', '${section.id}')">Magnolia Script</div>
                                    <div style="font-family: Rock-Road" onclick="selectDropdownOption('font-style-${section.id}', 'Rock Road', '${section.id}')">Rock Road</div>
                                    <div style="font-family: srabi-script" onclick="selectDropdownOption('font-style-${section.id}', 'Srabi Script', '${section.id}')">Srabi Script</div>
                                    <div style="font-family: Steel-City" onclick="selectDropdownOption('font-style-${section.id}', 'Steel City', '${section.id}')">Steel City</div>
                                    <div style="font-family: superstar-m54" onclick="selectDropdownOption('font-style-${section.id}', 'Superstar', '${section.id}')">Superstar</div>
                                    <div style="font-family: swzconbi" onclick="selectDropdownOption('font-style-${section.id}', 'SwitzerlandCond Italic', '${section.id}')">SwitzerlandCond Italic</div>
                                    <div style="font-family: swzconbn" onclick="selectDropdownOption('font-style-${section.id}', 'SwitzerlandCond', '${section.id}')">SwitzerlandCond</div>
                                </div>
                            </div>
                        </div>
                        <!-- Font Color -->
                        <div id="font-color-div-${section.id}">
                            <label for="font-color-${section.id}" class="font-style-label">Text Color:</label>
                            <div style="display: flex; align-items: center;">
                                <input type="color" id="font-color-picker-${section.id}" onchange="selectColorPickerOption('font-color-${section.id}', this.value, '${section.id}')" />
                                <label id="font-color-${section.id}" class="font-style-label" style="min-width: 70px;">Black</label>
                            </div>
                        </div>

                        <!-- Outline Color -->
                        <div id="outline-color-div-${section.id}">
                            <label for="outline-color-${section.id}" class="font-style-label">Outline Color:</label>
                            <div style="display: flex; align-items: center;">
                                <input type="color" id="outline-color-picker-${section.id}" />
                                <label id="outline-color-${section.id}" class="font-style-label">None</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="min-height:35px; padding-top:15px;">
                    <div style="display: flex; align-items: center;">
                        <h5 style="padding-right: 20px;">
                           4. Add Your Art:
                        </h5>
                        <!-- Drag and Drop Area -->
                        <div class="drop-zone-inline" id="drop-zone-${section.id}"
                            ondragover="event.preventDefault(); this.classList.add('drag-over');"
                            ondragleave="this.classList.remove('drag-over');"
                            ondrop="handleFileDrop(event, '${section.id}', '${section.title}'); this.classList.remove('drag-over');"
                            onclick="document.getElementById('upload-${section.id}').click();">

                            <img src="${window.shopifyAssetPaths.tools.uploadIcon}" alt="Upload Icon" class="upload-icon-inline">

                            <div class="upload-instructions-inline">
                            <strong>Drag & Drop</strong> your file here<br>
                            or <span class="upload-link">click to upload</span>
                            </div>

                            <input type="file" id="upload-${section.id}" class="file-input"
                                accept=".jpg,.jpeg,.png,.svg"
                                onchange="validateFileInput(event, '${section.id}'); addArt('${section.id}', '${section.title}');"
                                style="display: none;">
                        </div>
                    </div>
                </div>
                <label id="art-order-label-${section.id}" class="font-style-label" style="display: none">Art Order: </label>
                <div id="art-preview-${section.id}" class="art-preview" style="padding-bottom: 25px; display: flex; flex-wrap: wrap;"></div>
                <div style="min-height:35px;">
                    <h5>
                        5. Notes to Artist:
                    </h5>
                    <div>
                        <textarea id="notes-${section.id}" maxlength="200" class="notes-textarea placeholder-grey" style="width:100%; height:auto; border: 1px solid #838383; overflow: auto; resize: none; font-size: 18px;" placeholder="Enter any notes here..."></textarea>
                        <div><span id="char-count-${section.id}">200 characters remaining</span></div>
                    </div>
                </div>
                <div class="arrow-container">
                    <button id="prevButton-${section.id}" class="arrow-button2" onclick="prevSection()">
                        <div class="arrow"></div>
                        Prev
                    </button>
                    <button id="nextButton-${section.id}" class="arrow-button" onclick="nextSection()">
                        Next
                        <div class="arrow"></div>
                    </button>
                </div>
            </div>
        `;
        
        document.getElementById(tab).appendChild(sectionDiv);

        // Attach event listeners for color radios in this section
        const colorRadios = sectionDiv.querySelectorAll('.color-radio');
        const selectedColorSpan = sectionDiv.querySelector(`#selected-color-${section.id}`);

        const colorClassMap = {
            'None': 'none',
            'White': 'rgb(255, 255, 255)',
            'Black': 'rgb(6, 8, 8)',
            'Silver': 'rgb(194, 194, 194)',
            'Grey': 'rgb(141, 140, 140)',
            'Vegas Gold': 'rgb(192, 196, 148)',
            'Maroon': 'rgb(85, 33, 50)',
            'Cardinal': 'rgb(134, 40, 56)',
            'Red': 'rgb(197, 44, 44)',
            'Orange': 'rgb(218, 75, 18)',
            'Yellow Gold': 'rgb(255, 189, 13)',
            'Yellow': 'rgb(252, 230, 13)',
            'Kelly Green': 'rgb(68, 177, 92)',
            'Forest Green': 'rgb(52, 78, 48)',
            'Navy Blue': 'rgb(27, 35, 75)',
            'Royal Blue': 'rgb(47, 95, 167)',
            'Columbia Blue': 'rgb(143, 169, 221)',
            'Purple': 'rgb(115, 81, 158)',
        };

         // Initialize Pickr for color picking for each section
         const pickr = Pickr.create({
            el: `#color-picker-${section.id}`,
            theme: 'classic',
            lockOpacity: true,
            comparison: true,
            default: '#000000',
            swatches: null,
            closeWithKey: 'Escape',

            components: {
                // Main components
                preview: true,
                opacity: false,
                hue: true,

                // Input / output Options
                interaction: {
                    hex: true,
                    rgba: true,
                    hsla: true,
                    hsva: true,
                    cmyk: true,
                    input: true,
                    cancel: true,
                    clear: false,
                    save: true
                }
            }
        });

        // Store the Pickr instance for this section
        pickrInstances[section.name] = pickr;

        // Add the event listener for the 'Enter' key on the color input
        pickr.on('init', instance => {
            const el = instance.getRoot();
            const appElement = el.button.parentElement; // This is the actual .pcr-app DOM node

            if (appElement) {
            appElement.style.marginTop = '-37px';
            appElement.style.marginLeft = '137px';
            } else {
            console.error('Pickr root.app element not found');
            }

            el.button.addEventListener('keydown', e => {
                if (e.key === 'Enter' && instance === pickrInstances[currentSection]) {
                    e.preventDefault(); // Prevent default enter key behavior
                    instance.applyColor(); // "Saves" the color
                    instance.hide(); // Hides the modal
                    const selectedColor = instance.getColor().toHEXA().toString();
                    selectedColorSpan.textContent = selectedColor; // Update selected color display
                    updateCanvasColor(selectedColor); // Update the canvas color if needed
                }
            }, {capture: true});
            // Access the .pcr-interaction element
            const interactionElement = el.interaction.result.parentElement;
            
            if (interactionElement) {
                // Create the eyedropper button with an icon
                const eyeDropperButton = document.createElement('button');
                eyeDropperButton.classList.add('eye-dropper-button');
                eyeDropperButton.innerHTML = `<img src="${window.shopifyAssetPaths.tools.eyeDropper}" style="width: 24px; height: 24px;" alt="Pick Color" />`;

                // Append the eyedropper button to the .pcr-interaction element
                interactionElement.appendChild(eyeDropperButton);

                // Eyedropper API integration
                if ('EyeDropper' in window) {
                    const eyeDropper = new EyeDropper();

                    eyeDropperButton.addEventListener('click', async () => {
                        try {
                            const result = await eyeDropper.open();
                            instance.setColor(result.sRGBHex);
                        } catch (err) {
                            console.error('Eyedropper failed: ', err);
                        }
                    });
                } else {
                    console.warn('EyeDropper API is not supported in this browser.');
                    eyeDropperButton.disabled = true;
                }
            } else {
                console.error('Interaction element not found');
            }
        });

        // Add the event listener for the 'save' event on the Pickr instance
        pickr.on('save',(color, instance) => {
            if (instance == pickrInstances[currentSection]) {
                const selectedColor = color.toHEXA().toString();
                selectedColorSpan.textContent = selectedColor; // Update selected color display
                updateCanvasColor(selectedColor); // Update the canvas color if needed
                instance.hide();
            }
        });

        // Initialize Pickr for color picking for each section
        const pickr2 = Pickr.create({
            el: `#font-color-picker-${section.id}`,
            theme: 'classic',
            lockOpacity: true,
            comparison: true,
            default: '#000000',
            swatches: null,
            closeWithKey: 'Escape',

            components: {
                // Main components
                preview: true,
                opacity: false,
                hue: true,

                // Input / output Options
                interaction: {
                    hex: true,
                    rgba: true,
                    hsla: true,
                    hsva: true,
                    cmyk: true,
                    input: true,
                    cancel: true,
                    clear: false,
                    save: true
                }
            }
        });

        pickrInstances2[section.name] = pickr2

        // Add the event listener for the 'Enter' key on the color input
        pickr2.on('init', instance => {
            const el = instance.getRoot();

            el.button.addEventListener('keydown', e => {
                if (e.key === 'Enter' && instance === pickrInstances2[currentSection]) {
                    e.preventDefault();
                    instance.applyColor();
                    instance.hide();
                    const selectedColor = instance.getColor().toHEXA().toString();
                    selectColorPickerOption(`font-color-${section.id}`, selectedColor, `${section.id}`);
                }
            }); 

            const interactionElement = el.interaction.result.parentElement;
            
            if (interactionElement) {
                // Create the eyedropper button with an icon
                const eyeDropperButton = document.createElement('button');
                eyeDropperButton.classList.add('eye-dropper-button');
                eyeDropperButton.innerHTML = `<img src="${window.shopifyAssetPaths.tools.eyeDropper}" style="width: 24px; height: 24px;" alt="Pick Color" />`;;

                // Append the eyedropper button to the .pcr-interaction element
                interactionElement.appendChild(eyeDropperButton);

                // Eyedropper API integration
                if ('EyeDropper' in window) {
                    const eyeDropper = new EyeDropper();

                    eyeDropperButton.addEventListener('click', async () => {
                        try {
                            const result = await eyeDropper.open();
                            instance.setColor(result.sRGBHex);
                        } catch (err) {
                            console.error('Eyedropper failed: ', err);
                        }
                    });
                } else {
                    console.warn('EyeDropper API is not supported in this browser.');
                    eyeDropperButton.disabled = true;
                }
            } else {
                console.error('Interaction element not found');
            }
        });

        // Add the event listener for the 'save' event on the Pickr instance
        pickr2.on('save',(color, instance) => {
            if (instance == pickrInstances2[currentSection]) {
                const selectedColor = color.toHEXA().toString();
                selectColorPickerOption(`font-color-${section.id}`, selectedColor, `${section.id}`);
                instance.hide();
            }
        });

        // Initialize Pickr for color picking for each section
        const pickr3 = Pickr.create({
            el: `#outline-color-picker-${section.id}`,
            theme: 'classic',
            lockOpacity: true,
            comparison: true,
            default: null,
            swatches: null,
            closeWithKey: 'Escape',

            components: {
                // Main components
                preview: true,
                opacity: false,
                hue: true,

                // Input / output Options
                interaction: {
                    hex: true,
                    rgba: true,
                    hsla: true,
                    hsva: true,
                    cmyk: true,
                    input: true,
                    cancel: true,
                    clear: true,
                    save: true
                }
            }
        });

        pickrInstances3[section.name] = pickr3

        // Add the event listener for the 'Enter' key on the color input
        pickr3.on('init', instance => {
            const el = instance.getRoot();

            el.button.addEventListener('keydown', e => {
                if (e.key === 'Enter' && instance === pickrInstances3[currentSection]) {
                    e.preventDefault();
                    instance.applyColor();
                    instance.hide();
                    const selectedColor = instance.getColor().toHEXA().toString();
                    selectColorPickerOption(`outline-color-${section.id}`, selectedColor, `${section.id}`);
                }
            });            

            const interactionElement = el.interaction.result.parentElement;
            
            if (interactionElement) {
                // Create the eyedropper button with an icon
                const eyeDropperButton = document.createElement('button');
                eyeDropperButton.classList.add('eye-dropper-button');
                eyeDropperButton.innerHTML = `<img src="${window.shopifyAssetPaths.tools.eyeDropper}" style="width: 24px; height: 24px;" alt="Pick Color" />`;;

                // Append the eyedropper button to the .pcr-interaction element
                interactionElement.appendChild(eyeDropperButton);

                // Eyedropper API integration
                if ('EyeDropper' in window) {
                    const eyeDropper = new EyeDropper();

                    eyeDropperButton.addEventListener('click', async () => {
                        try {
                            const result = await eyeDropper.open();
                            instance.setColor(result.sRGBHex);
                        } catch (err) {
                            console.error('Eyedropper failed: ', err);
                        }
                    });
                } else {
                    console.warn('EyeDropper API is not supported in this browser.');
                    eyeDropperButton.disabled = true;
                }
            } else {
                console.error('Interaction element not found');
            }
        });

        // Add the event listener for the 'save' event on the Pickr instance
        pickr3.on('save',(color, instance) => {
            if (instance == pickrInstances3[currentSection]) {
                if(color !== null){
                    const selectedColor = color.toHEXA().toString();
                    selectColorPickerOption(`outline-color-${section.id}`, selectedColor, `${section.id}`);
                }
                else{
                    selectColorPickerOption(`outline-color-${section.id}`,  null, `${section.id}`);
                }
                instance.hide();
            }
        });

        function updateSelectedColor() {
            const selectedRadio = sectionDiv.querySelector('.color-radio:checked');
            const textInput = document.getElementById(`text-input-${section.id}`);
            if (selectedRadio) {
                selectedColorSpan.textContent = selectedRadio.value;
                const canvas = document.getElementById(section.title.replace(' ', '') + 'Canvas');
                if (canvas) {
                    const context = canvas.getContext('2d');
                    context.fillStyle = colorClassMap[selectedRadio.value];
                    context.fill();
                    context.strokeStyle = '#5A5A5A';
                    context.stroke();
                    if (section.title === "Front Valance") {
                        updateValanceLogo(selectedRadio.value);
                    }
                    if (textInput.value !== '') {
                        updateCanvasText(section);
                    }
                }
            }
        }
        
        function updateCanvasColor(color) {
            const canvas = document.getElementById(section.title.replace(' ', '') + 'Canvas');
            const textInput = document.getElementById(`text-input-${section.id}`);
            if (canvas) {
                const context = canvas.getContext('2d');
                context.fillStyle = color;
                context.fill();
                context.strokeStyle = '#5A5A5A';
                context.stroke();
                if (section.title === "Front Valance") {
                    updateValanceLogo(color);
                }
                if (textInput.value !== '') {
                    updateCanvasText(section);
                }
            }

            // Uncheck radio buttons in the current section
            const allRadios = document.querySelectorAll('.color-radio');
            allRadios.forEach(radio => {
                if (radio.id.includes(currentSection) && currentSection == section.name) {
                    radio.checked = false;
                }
            });
            
        }

        function hexToRgb(hex) {
            // Remove the leading # if present
            hex = hex.replace(/^#/, '');
        
            // Convert 3-digit HEX to 6-digit HEX
            if (hex.length === 3) {
                hex = hex.split('').map(char => char + char).join('');
            }
        
            const bigint = parseInt(hex, 16);
            const r = (bigint >> 16) & 255;
            const g = (bigint >> 8) & 255;
            const b = bigint & 255;
        
            return { r, g, b };
        }
        
        function updateValanceLogo(color){
            const logo = document.getElementById('ValanceLogo');
            switch (color){
                // Black Logo is used
                case 'White':
                case 'Silver':
                case 'Vegas Gold':
                case 'Yellow Gold':
                case 'Yellow':
                     logo.src = `${window.shopifyAssetPaths.logos.blackValance}`;
                     break;

                // White Logo is used
                case 'Black':
                case 'Grey':
                case 'Maroon':
                case 'Cardinal':
                case 'Red':
                case 'Orange':
                case 'Forest Green':
                case 'Navy Blue':
                case 'Purple':
                case 'Royal Blue':
                case 'Kelly Green':
                case 'Columbia Blue':
                    logo.src = `${window.shopifyAssetPaths.logos.whiteValance}`;
                    break;
            }
            if(color.includes("#")){
                const rgb = hexToRgb(color);

                // Calculate brightness (perceived brightness)
                const brightness = Math.sqrt(
                    0.299 * (rgb.r * rgb.r) +
                    0.587 * (rgb.g * rgb.g) +
                    0.114 * (rgb.b * rgb.b)
                );

                // Choose logo based on brightness
                if (brightness > 150) { // Adjust this threshold as needed
                    logo.src = `${window.shopifyAssetPaths.logos.blackValance}`;
                } else {
                    logo.src = `${window.shopifyAssetPaths.logos.whiteValance}`;
                }
            }
        }

        colorRadios.forEach(radio => {
            radio.addEventListener('change', updateSelectedColor);
        });

        // Initialize the selected color on page load
        updateSelectedColor();
    });


    // Add the new "Preview Now" section
    const previewSection = document.createElement('div');
    previewSection.id = 'preview-section';
    previewSection.classList.add('section');
    previewSection.style.display = 'none'; // Initially hidden
    previewSection.style.marginTop = '0px';

    previewSection.innerHTML = `
    <h5>Contact Information</h5>
    <form id="contactForm">
        <!-- Email + Confirm Email -->
        <div class="form-group-row">
        <div class="form-col" style="flex: 1;">
            <label for="email" class="font-style-label">1. Email Address:</label>
            <input type="email" id="email" name="email" class="text-input placeholder-grey" required placeholder="Ex. customer_service@fttf.com" oninput="validateEmail()">
            <span id="email-error" style="color: red; display: none;">Emails do not match</span>
        </div>
        <div class="form-col" style="flex: 1;">
            <label for="confirmEmail" class="font-style-label">2. Confirm Email:</label>
            <input type="email" id="confirmEmail" name="confirmEmail" class="text-input placeholder-grey" required placeholder="Retype email address" oninput="validateEmail()">
        </div>
        </div>
        
        <!-- Name + Phone -->
        <div class="form-group-row">
        <div class="form-col" style="flex: 1; ">
            <label for="userName" class="font-style-label">3. Customer Name:</label>
            <input type="text" id="userName" name="name" class="text-input placeholder-grey" required placeholder="Ex. John Doe">
        </div>
        <div class="form-col" style="flex: 1; ">
            <label for="phone" class="font-style-label">4. Phone Number:</label>
            <input type="text" id="phone" name="phone" class="text-input placeholder-grey" required placeholder="Ex. (800) 747-9013" oninput="formatPhoneNumber(this)">
            <span id="phone-error" style="color: red; display: none;">Please enter a valid 10-digit phone number.</span>
        </div>
        </div>
        
        <!-- School/Club + Sales Rep -->
        <div class="form-group-row">
        <div class="form-col" style="flex: 1;">
            <label for="schoolClub" class="font-style-label">5. School/Club:</label>
            <input type="text" id="schoolClub" name="schoolClub" class="text-input placeholder-grey" placeholder="Optional">
        </div>
        <div class="form-col" style="flex: 1;">
            <label for="salesRep" class="font-style-label">6. Sales Rep (if known):</label>
            <input type="text" id="salesRep" name="salesRep" class="text-input placeholder-grey" placeholder="Optional">
        </div>
        </div>

        <!-- Street Address -->
        <div class="form-row">
            <label for="street" class="font-style-label">7. Street Address:</label>
            <input type="text" id="street" name="street" class="text-input placeholder-grey" style="width: 450px;" required placeholder="Ex. 2341 Plum St.">
        </div>

        
        <!-- City + State + Zip -->
        <div class="form-group-row">
        <div class="form-col" style="flex: 1; min-width: 150px;">
            <label for="city" class="font-style-label">City:</label>
            <input type="text" id="city" name="city" class="text-input placeholder-grey" required placeholder="Ex. Edwardsville">
        </div>
        <div class="form-col" style="width: 80px;">
            <label for="state" class="font-style-label">State:</label>
            <div class="custom-select-wrapper">
                <select id="state" class="custom-select" required>
                    <option value="" disabled selected>State</option>
                </select>
            </div>
        </div>
        <div class="form-col" style="flex: 1; min-width: 120px;">
            <label for="zip" class="font-style-label">Zip Code:</label>
            <input type="text" id="zip" name="zip" class="text-input placeholder-grey" required placeholder="Ex. 62025-1234" oninput="formatZipCode(this)">
            <span id="zip-error" style="color: red; display: none;">Please enter a valid zip code.</span>
        </div>
        </div>
        
        <!-- Ready to order + Design Name -->
        <div class="form-group-row">
        <!-- Ready to order dropdown -->
        <div class="form-col" style="flex: 1;">
            <label for="priority" class="font-style-label">8. Ready to order:</label>
            <div class="custom-select-wrapper">
                <select class="custom-select" id="priority" required>
                    <option value="" disabled selected>--Select an Option--</option>
                    <option value="No, I am just browsing.">No, I am just browsing.</option>
                    <option value="Yes, but I want some help.">Yes, but I want some help.</option>
                    <option value="Yes, I am ready to order!">Yes, I am ready to order!</option>
                </select>
            </div>
        </div>

        <!-- Design Name -->
        <div class="form-col" style="flex: 1;">
            <label for="Tent-Name" class="font-style-label">9. Design Name:</label>
            <input type="text" id="Tent-Name" name="design" class="text-input placeholder-grey" required placeholder="Ex. Design 1">
        </div>
        </div>

        
        <!-- Buttons -->
        <div class="arrow-container" style="padding-top: 20px;">
        <button type="button" class="arrow-button2" onclick="goBackToSections()">
            <div class="arrow"></div>
            Back to Editing
        </button>
        <button type="submit" id="submit-button" class="arrow-button" onclick="submitForm()">
            Submit
            <div class="arrow"></div>
        </button>
        </div>
    </form>
        
    `;

    document.getElementById('tent-submission').appendChild(previewSection);
    populateStates();

    function populateStates(){
        const statesSelect = document.getElementById("state");
        const states = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

        states.forEach(state => {
            const option = document.createElement("option");
            option.value = state;
            option.textContent = `${state}`;
            statesSelect.appendChild(option);
        });
    }

    // Function to handle input color change
    function handleInputColorChange() {
        const inputs = document.querySelectorAll('.text-input');
        inputs.forEach(input => {
            input.addEventListener('input', () => {
                if (input.value === '') {
                    input.classList.add('placeholder-grey'); // Add grey color class for placeholder
                    input.classList.remove('input-black'); // Remove black color class for input text
                } else {
                    input.classList.remove('placeholder-grey'); // Remove grey color class
                    input.classList.add('input-black'); // Add black color class
                }
            });
            // Initial check
            if (input.value === '') {
                input.classList.add('placeholder-grey');
                input.classList.remove('input-black');
            } else {
                input.classList.remove('placeholder-grey');
                input.classList.add('input-black');
            }
        });
    }

    // Call the function to add event listeners to inputs
    handleInputColorChange();
}

function toggleDropdown2(id) {
    document.getElementById(id).classList.toggle("show");
}

function selectDropdownOption2(dropdownId, value, inputId) {
    const button = document.getElementById(`${dropdownId}-button`);
    button.textContent = value;
    button.style.color = '#000000'; // Change text color to black
    const input = document.getElementById(inputId);
    input.value = value;
    toggleDropdown2(dropdownId);
}

function validateEmail() {
    const email = document.getElementById('email').value;
    const confirmEmail = document.getElementById('confirmEmail').value;
    const emailError = document.getElementById('email-error');
    
    if (email === confirmEmail) {
        emailError.style.display = 'none';
    } else {
        emailError.style.display = 'block';
    }
}

function formatPhoneNumber(input) {
    // Remove non-numeric characters
    let phone = input.value.replace(/\D/g, '');

    // Limit to 10 digits
    phone = phone.substring(0, 10);

    // Format the phone number
    let formattedPhone = '';
    if (phone.length > 6) {
        formattedPhone = `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6, 10)}`;
    } else if (phone.length > 3) {
        formattedPhone = `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}`;
    } else if (phone.length > 0) {
        formattedPhone = `(${phone.substring(0, 3)}`;
    }

    // Update the input value
    input.value = formattedPhone;
}

function formatZipCode(input) {
    let zip = input.value.replace(/\D/g, '').substring(0, 9); // Remove non-digits and limit to 9 characters
    const first = zip.substring(0, 5);
    const last = zip.substring(5, 9);

    if (zip.length > 5) {
        input.value = `${first}-${last}`;
    } else {
        input.value = first;
    }
}

function sanitizeInput(value) {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        "/": '&#x2F;',
    };
    const reg = /[&<>"'/]/g;
    return value.replace(reg, match => map[match]);
}

function sanitizeInputField(input) {
    const cursorPosition = input.selectionStart;
    const originalLength = input.value.length;

    input.value = sanitizeInput(input.value);

    // Adjust the cursor position if necessary
    const newLength = input.value.length;
    const diff = newLength - originalLength;
    input.setSelectionRange(cursorPosition + diff, cursorPosition + diff);
}

function sanitizeFormInputs(event) {
    // Prevent form submission
    event.preventDefault();

    const inputs = document.querySelectorAll('input[type="text"], input[type="email"], textarea');
    inputs.forEach(input => {
        input.value = sanitizeInput(input.value);
    });
}

function cleanInput(input, regex) {
    
}

function validateForm() {
    const priority = document.getElementById('priority').value.trim();
    const state = document.getElementById('state').value.trim();
    const requiredFields = document.querySelectorAll('#contactForm [required]');
    console.log(requiredFields);
    let isValid = true;

    // Check all required fields
    requiredFields.forEach(field => {
        if (!field.value.trim()) {
            isValid = false;
            field.style.borderColor = 'red'; // Highlight empty required fields
        } else {
            field.style.borderColor = ''; // Reset border color
        }
    });

    // Check phone number
    const phone = document.getElementById('phone').value.replace(/\D/g, '');
    const phoneError = document.getElementById('phone-error');
    if (phone.length !== 10) {
        isValid = false;
        document.getElementById('phone').style.borderColor = 'red';
        phoneError.style.display = 'block';
    } else {
        document.getElementById('phone').style.borderColor = ''; // Reset border color if valid
        phoneError.style.display = 'none';
    }

    // Check zip code
    const zip = document.getElementById('zip').value.replace(/\D/g, '');
    const zipError = document.getElementById('zip-error');
    if (zip.length !== 5 && zip.length !== 9) {
        isValid = false;
        document.getElementById('zip').style.borderColor = 'red';
        zipError.style.display = 'block';
    } else {
        document.getElementById('zip').style.borderColor = ''; // Reset border color if valid
        zipError.style.display = 'none';
    }

    return isValid;
}

function enforceCharacterLimit(event, maxLength) {
    const target = event.target;
    if (target.value.length > maxLength) {
        target.value = target.value.slice(0, maxLength);
        alert(`Maximum character limit of ${maxLength} reached`);
    }
    updateCharacterCounter(event, maxLength);
}

function updateCharacterCounter(event, maxLength) {
    const target = event.target;
    const charCountSpan = document.getElementById(`char-count-${target.id.split('-')[1]}`);
    const remainingChars = maxLength - target.value.length;
    charCountSpan.textContent = `${remainingChars} characters remaining`;
}